"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CoachingRecSchema () {
        return CoachingRecSchema;
    },
    get CompetenciesSchema () {
        return CompetenciesSchema;
    },
    get CompetencyRadarAxisSchema () {
        return CompetencyRadarAxisSchema;
    },
    get EmployeeSummarySchema () {
        return EmployeeSummarySchema;
    },
    get FeedbackInsightsSchema () {
        return FeedbackInsightsSchema;
    },
    get FeedbackStatsSchema () {
        return FeedbackStatsSchema;
    },
    get GenerationInfoSchema () {
        return GenerationInfoSchema;
    },
    get GetEmployeeSummaryResponse () {
        return GetEmployeeSummaryResponse;
    },
    get GoalsInsightsSchema () {
        return GoalsInsightsSchema;
    },
    get GoalsStatsSchema () {
        return GoalsStatsSchema;
    },
    get MeetingsInsightsSchema () {
        return MeetingsInsightsSchema;
    },
    get MeetingsStatsSchema () {
        return MeetingsStatsSchema;
    },
    get ReviewsInsightsSchema () {
        return ReviewsInsightsSchema;
    },
    get ReviewsStatsSchema () {
        return ReviewsStatsSchema;
    },
    get RightNowSchema () {
        return RightNowSchema;
    },
    get SamplingStrategyContractSchema () {
        return SamplingStrategyContractSchema;
    },
    get SectionNarrativesSchema () {
        return SectionNarrativesSchema;
    },
    get SignalCountsSchema () {
        return SignalCountsSchema;
    },
    get TimeframeSchema () {
        return TimeframeSchema;
    },
    get TopHighlightsSchema () {
        return TopHighlightsSchema;
    }
});
const _zod = require("zod");
const TimeframeSchema = _zod.z.enum([
    "all",
    "12mo",
    "90d",
    "30d"
]);
const SamplingStrategyContractSchema = _zod.z.enum([
    "first_n_recent",
    "stratified_time",
    "embedding_top_k"
]);
const NullableNumber = _zod.z.number().nullable();
const CoachingRecSchema = _zod.z.object({
    // Keep in sync with the generation schema (packages/ai employeeSummaryNarrativesSchema)
    // and the section_narratives domains — competencies is a valid coaching section.
    section: _zod.z.enum([
        "reviews",
        "goals",
        "meetings",
        "feedback",
        "competencies",
        "general"
    ]),
    suggestion: _zod.z.string()
});
const TopHighlightsSchema = _zod.z.object({
    summary: _zod.z.string(),
    accomplishments: _zod.z.array(_zod.z.string()),
    areas_of_improvement: _zod.z.array(_zod.z.string())
});
const GenerationInfoSchema = _zod.z.object({
    status: _zod.z.enum([
        "complete",
        "in_progress",
        "failed"
    ]),
    model: _zod.z.string(),
    prompt_hash: _zod.z.string(),
    duration_ms: _zod.z.number(),
    task_id: _zod.z.string().nullable()
});
const SignalCountsSchema = _zod.z.object({
    reviews: _zod.z.number(),
    feedback_received: _zod.z.number(),
    feedback_given: _zod.z.number(),
    goals: _zod.z.number(),
    meetings: _zod.z.number()
});
const ReviewsStatsSchema = _zod.z.object({
    assigned: _zod.z.number(),
    forms_authored_for_others: _zod.z.number(),
    completed: _zod.z.number(),
    overdue: _zod.z.number(),
    last_review_date: _zod.z.string().nullable()
});
const GoalsStatsSchema = _zod.z.object({
    assigned: _zod.z.number(),
    completed: _zod.z.number(),
    overdue: _zod.z.number(),
    created: _zod.z.number(),
    avg_progress: _zod.z.number().nullable()
});
const FeedbackStatsSchema = _zod.z.object({
    unique_givers: _zod.z.number(),
    requested: _zod.z.number(),
    requested_response_rate: _zod.z.number().nullable(),
    avg_response_time_days: _zod.z.number().nullable()
});
const MeetingsStatsSchema = _zod.z.object({
    one_on_ones_with_manager: _zod.z.number(),
    action_items_complete: _zod.z.number(),
    action_items_incomplete: _zod.z.number(),
    avg_action_item_completion_days: _zod.z.number().nullable(),
    held_meetings: _zod.z.number(),
    participated_meetings: _zod.z.number(),
    participation_rate: _zod.z.number().nullable()
});
const SectionNarrativesSchema = _zod.z.object({
    competencies: _zod.z.string().nullable()
});
const RightNowSchema = _zod.z.object({
    momentum: _zod.z.array(_zod.z.string()),
    watch_outs: _zod.z.array(_zod.z.string())
});
const ReviewsInsightsSchema = _zod.z.object({
    strengths: _zod.z.array(_zod.z.string()),
    areas_of_opportunity: _zod.z.array(_zod.z.string()),
    goals_from_review_creation: _zod.z.array(_zod.z.string()),
    goals_from_review_discussions: _zod.z.array(_zod.z.string())
});
const GoalsInsightsSchema = _zod.z.object({
    execution: _zod.z.array(_zod.z.string()),
    patterns_risks: _zod.z.array(_zod.z.string())
});
const FeedbackInsightsSchema = _zod.z.object({
    patterns: _zod.z.array(_zod.z.string())
});
const MeetingsInsightsSchema = _zod.z.object({
    patterns: _zod.z.array(_zod.z.string())
});
const CompetencyRadarAxisSchema = _zod.z.object({
    label: _zod.z.string(),
    current: NullableNumber,
    expected: NullableNumber
});
const CompetenciesSchema = _zod.z.object({
    counts: _zod.z.object({
        meets: _zod.z.number(),
        exceeds: _zod.z.number(),
        below: _zod.z.number()
    }),
    company_wide: _zod.z.array(CompetencyRadarAxisSchema),
    role: _zod.z.array(CompetencyRadarAxisSchema)
});
const EmployeeSummarySchema = _zod.z.object({
    user_id: _zod.z.string(),
    company_id: _zod.z.string(),
    timeframe: TimeframeSchema,
    schema_version: _zod.z.literal(5),
    generated_at: _zod.z.string(),
    source_watermark: _zod.z.string(),
    is_stale: _zod.z.boolean(),
    dumb_mode: _zod.z.boolean(),
    generation: GenerationInfoSchema,
    signal_counts: SignalCountsSchema,
    reviews_stats: ReviewsStatsSchema.nullable(),
    goals_stats: GoalsStatsSchema.nullable(),
    feedback_stats: FeedbackStatsSchema.nullable(),
    meetings_stats: MeetingsStatsSchema.nullable(),
    right_now: RightNowSchema.nullable(),
    reviews_insights: ReviewsInsightsSchema.nullable(),
    goals_insights: GoalsInsightsSchema.nullable(),
    feedback_insights: FeedbackInsightsSchema.nullable(),
    meetings_insights: MeetingsInsightsSchema.nullable(),
    top_highlights: TopHighlightsSchema.nullable(),
    coaching_recommendations: _zod.z.array(CoachingRecSchema).nullable(),
    section_narratives: SectionNarrativesSchema.nullable(),
    competencies: CompetenciesSchema.nullable()
});
const GetEmployeeSummaryResponse = EmployeeSummarySchema;
